<template>
  <component v-if="layout" :is="layout" :key="organizationStore.currentOrganizationId">
    <slot />
  </component>
</template>

<script setup lang="ts">
  import { shallowRef, watch } from 'vue'
  import FullScreenLayout from './FullScreenLayout.vue'
  import { useRoute } from 'vue-router'
  import type { Component } from 'vue'
  import { useOrganizationStore } from '../../../stores/organization.store'
  import PrintLayout from './print/PrintLayout.vue'
  import SidebarLayout from './SidebarLayout.vue'
  import SettingsLayout from './SettingsLayout.vue'

  const layout = shallowRef<Component | null>(null)
  const route = useRoute()

  const organizationStore = useOrganizationStore()

  watch(
    () => route.meta,
    (meta) => {
      if (meta.layout == 'full-screen') {
        layout.value = FullScreenLayout
        return
      }
      if (meta.layout == 'print') {
        layout.value = PrintLayout
        return
      }
      if (meta.layout == 'settings') {
        layout.value = SettingsLayout
        return
      }

      layout.value = SidebarLayout
      return
    },
    { immediate: true },
  )
</script>
